<template>
  <div>
    <qyzztx />
  </div>
</template>

<script>
// 获取接口地址
import qyzztx from '@/components/tztx/qyzzTx'

export default {
  name: 'Qyzzdqtx',
  components: {
    qyzztx
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
